var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Vue from 'vue';
import ToolBar from '../../parts/ToolBar.vue';
import WalletBar from '../../parts/WalletBar.vue';
import TransactionModule from '../../mixins/TransactionModule';
import { DateTimeFormatter } from 'js-joda';
import { MUTATION_TYPES } from "../../../lib/mutationTypes";
const transactionDefault = {};
export default Vue.extend({
    mixins: [TransactionModule],
    components: { ToolBar, WalletBar },
    name: "TransactionList",
    data() {
        return {
            loadingTransaction: false,
            transactions: Object.assign({}, transactionDefault)
        };
    },
    methods: {
        settleTransactions() {
            this.transactions = {};
            const formatter = DateTimeFormatter.ofPattern('yyyyMMdd');
            const transactions = (this.unconfirmedTransactions || []).concat(this.confirmedTransactions || []);
            for (let transaction of transactions) {
                const dateKey = transaction.timeWindow.timeStamp.format(formatter);
                if (dateKey in this.transactions) {
                    this.transactions[dateKey].push(transaction);
                }
                else {
                    this.transactions[dateKey] = [transaction];
                }
            }
        },
        goToDetail(transaction) {
            this.$store.commit(MUTATION_TYPES.SET_TRANSACTION, transaction);
            this.$router.push('/transaction/detail');
        }
    },
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loadingTransaction = true;
            yield this.fetchTransactions(100, true, () => {
                this.settleTransactions();
                this.loadingTransaction = false;
            });
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/transaction/TransactionList.vue
// module id = 608
// module chunks = 1